import Select, { Props as ReactSelectProps } from "react-select";
type Props<Option = unknown> = ReactSelectProps<Option>

export default function RichFormSelect({ ...props }: Props) {
  return (
    <Select
    
      {...props}
    />
  );
};
